import { Message } from "primereact/message";
import { Skeleton } from "primereact/skeleton";

const MeaDataTableLoadingQuery = ({ query }) => {
  if (query?.isError) {
    return (
      <Message
        severity="error"
        text="Erreur de récuperation des données!"
        className="block col-12 xl:col-6 mt-3 mb-3"
      />
    );
  } else {
    if (query?.isLoading || query?.isFetching) {
      return (
        <div className="card">
          <div className="flex flex-column gap-3">
            
            {/* Table skeleton */}
            <div className="flex flex-column gap-2">
              {[...Array(3)].map((_, index) => (
                <div key={index} className="flex align-items-center gap-3 p-3 ">
                  <Skeleton width="3rem" height="1.5rem" />
                  <Skeleton width="18rem" height="3rem" />
                  <Skeleton width="8rem" height="2rem" />
                  <Skeleton width="10rem" height="2rem" />
                  <Skeleton width="8rem" height="2rem" />
                  <Skeleton width="8rem" height="2rem" />
                  <Skeleton width="8rem" height="2rem" />
                </div>
              ))}
            </div>
            {/* Pagination skeleton */}
            <div className="flex justify-content-between align-items-center">
              <Skeleton width="200px" height="2rem" />
              <div className="flex gap-2">
                <Skeleton width="2rem" height="2rem" />
                <Skeleton width="2rem" height="2rem" />
                <Skeleton width="2rem" height="2rem" />
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return "Pas d'éléments";
    }
  }
};

export default MeaDataTableLoadingQuery;
